"use strict";

import { nxtInOut } from "../animations";
import { navReusables, nav } from "./nav-interactions";
import addSlideCounter from "./slide-counter";
import generateTOC from "./generate-toc";
import tocObserver from "./observe-toc";
import gsap from "gsap";
import { Observer } from "gsap/all";
// import { default as cc } from "./helpers";

const study = (container) => {
	gsap.registerPlugin(Observer);

	const mainNav = document.querySelector(".nav__main");

	/* Initializers */
	window.scrollTo({ top: 0, left: 0, behavior: "instant" });
	mainNav.classList.remove("solid--white");
	if (window.scrollY === 0 && mainNav.classList.contains("hide")) navReusables.toggleNav("main");

	/* Scroll interactions */
	const toggleNav = (vel) => {
		if (window.scrollY < 50) {
			navReusables.addRemoveClass("main", "remove");
			mainNav.classList.remove("solid--white");
		} else if (vel > 20) navReusables.addRemoveClass("main", "add");
		else if (vel < -6000) {
			navReusables.addRemoveClass("main", "remove");
			mainNav.classList.add("solid--white");
		}
	};

	Observer.create({
		target: window,
		type: "scroll",
		onUp: (data) => toggleNav(data.velocityY),
		onDown: (data) => toggleNav(data.velocityY),
	});

	/* Next project interactions */
	const nxtProjCon = container.querySelector(".next-proj-container");
	const projects = nxtProjCon.querySelectorAll(".project");
	const btns = nxtProjCon.querySelectorAll("#rightBtn, #leftBtn");
	const slideContainer = nxtProjCon.querySelector(".slide-counter");
	const slideItems =
		projects.length > 1 ? addSlideCounter(slideContainer, projects.length) : null;

	let currProj = 0;
	let prevProj;

	const toggleCounter = (proj) => {
		slideItems?.forEach((el, i) => {
			if (proj === i) el.classList.add("active");
			else el.classList.remove("active");
		});
	};

	const toggleBtns = (proj) => {
		if (projects.length > 1) {
			if (proj === 0) {
				btns[1].style.display = "none";
				btns[0].style.display = "flex";
			} else if (proj === projects.length - 1) {
				btns[0].style.display = "none";
				btns[1].style.display = "flex";
			} else {
				btns[0].style.display = "flex";
				btns[1].style.display = "flex";
			}
		} else {
			btns.forEach((btn) => {
				btn.style.display = "none";
			});
		}
	};

	const nxtProj = (e) => {
		const el =
			e.target.tagName === "svg"
				? e.target.parentElement
				: e.target.tagName === "path"
				? e.target.parentElement.parentElement
				: e.target;

		el.removeEventListener("click", nxtProj);

		if (el.id === "leftBtn") {
			prevProj = currProj;
			currProj -= 1;
			toggleBtns(currProj);
			toggleCounter(currProj);
			nxtInOut(currProj, prevProj);
		} else if (el.id === "rightBtn") {
			prevProj = currProj;
			currProj += 1;
			toggleBtns(currProj);
			toggleCounter(currProj);
			nxtInOut(currProj, prevProj);
		}

		setTimeout(() => {
			el.addEventListener("click", nxtProj);
		}, 900);
	};

	const changeProj = (e) => {
		const el = e.target;

		el.removeEventListener("click", changeProj);

		prevProj = currProj;
		currProj = e.target.id - 1;
		toggleBtns(currProj);
		toggleCounter(currProj);
		nxtInOut(currProj, prevProj);

		setTimeout(() => {
			el.addEventListener("click", changeProj);
		}, 900);
	};

	toggleBtns(currProj);
	toggleCounter(currProj);

	btns.forEach((btn) => {
		btn.addEventListener("click", nxtProj);
	});
	slideItems?.forEach((item) => {
		item.addEventListener("click", changeProj);
	});

	/* Table of content interactions */
	const article = container.querySelector("article");
	generateTOC(article);
	tocObserver(article);

	/* Chapter image styling */
	const chapImages = container.getElementsByClassName("full-bleed");
	const projColor = container.querySelector("article").getAttribute("data-color");

	Array.from(chapImages).forEach((img) => {
		img.style.backgroundColor = projColor;
	});

	// Deprecated code
	// const nav = document.querySelector(".nav__main");

	// let lastScrollPosition = 0;

	/* const scrollIx = function () {
		const scrollAmt = scrollY;

		if (scrollAmt > lastScrollPosition) {
			navReusables.addRemoveClass("main", "add");
		} else if (scrollAmt < lastScrollPosition) {
			navReusables.addRemoveClass("main", "remove");
		}

		lastScrollPosition = scrollAmt;
	}; */

	/* const clearStyle = () => {
		nav.attributeStyleMap.clear();

		window.removeEventListener("scroll", scrollIx);
		nav.children[1].removeEventListener("click", clearStyle);
	}; */

	// window.addEventListener("scroll", scrollIx);
	// nav.children[1].addEventListener("click", clearStyle);

	// Array.from(chapImages).forEach((img) => {
	// const chapNumb = img.querySelector("h4");

	// const numbOutline = document.createElement("h4");
	// numbOutline.classList.add("outline");
	// numbOutline.textContent = chapNumb.textContent;
	// img.children[0].appendChild(numbOutline);

	// img.style.backgroundColor = projColor;
	// img.style.setProperty("--color", cc.changeColorHex(projColor, 100, 86));
	// });
};

export default study;
